import React, { useRef } from 'react';
import { GoogleMap, LoadScript } from '@react-google-maps/api';

export default function MapComponent() {
  // Referenca na mapu
  const mapRef = useRef(null);

  // Stil kontejnera mape
  const containerStyle = {
    width: '100%',
    height: '400px'
  };

  // Centar mape (možeš promijeniti koordinate)
  const center = {
    lat: 44.787197, // primjer: Beograd
    lng: 20.457273
  };

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={12}
        onLoad={map => (mapRef.current = map)}
      >
        {/* Samo mapa, nema markera */}
      </GoogleMap>
    </LoadScript>
  );
}
